import { Flex } from "@chakra-ui/layout";
import { Input, Text, Checkbox } from "@chakra-ui/react";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { AssuntoMensagem, MensagemForm } from "core/features/mensagens/typings";
import colors from "core/resources/theme/colors";
import { Control, UseFormGetValues, UseFormSetValue } from "react-hook-form";
import Field from "ui/components/Input/Field";
import { WindowState } from ".";
import MessageEditor from "../MessageEditor";
import SelectDestinos from "../SelectDestinos";
import SelectAssuntoMensagem from "./SelectAssuntoMensagem";
import { useCallback } from "react";
import { TipoEntidadeEnum } from "core/resources/enums/conta";

interface FormNovaMensagemProps {
  windowState: WindowState;
  control: Control<MensagemForm, object>;
  setValue: UseFormSetValue<MensagemForm>;
  getValues: UseFormGetValues<MensagemForm>;
  form: MensagemForm;
  compact?: boolean;
}

function FormNovaMensagem({
  windowState,
  control,
  form,
  setValue,
  getValues,
  compact = false,
}: FormNovaMensagemProps) {
  const { tenant } = useCurrentTenant();

  const selectSize = windowState === "maximized" ? "large" : "small";
  const inputSize = windowState === "maximized" ? "md" : "sm";

  const onChange = useCallback(
    (html: string | undefined, plainText?: string) => {
      setValue("conteudo", html || "");
      setValue("conteudoPlain", plainText);
    },
    [setValue]
  );

  return (
    <>
      {compact ? null : (
        <>
          <SelectDestinos
            tenantId={tenant.id}
            control={control}
            form={form}
            setValue={setValue}
            getValues={getValues}
            inputSize={inputSize}
            selectSize={selectSize}
            showEmail
            showPessoa
            tiposPessoa={[
              TipoEntidadeEnum.Condomino,
              TipoEntidadeEnum.Fornecedor,
              TipoEntidadeEnum.Funcionario,
              TipoEntidadeEnum.Cliente,
              TipoEntidadeEnum.Outros,
            ]}
          />

          <Field
            name="enviarEmail"
            control={control}
            render={({ field }) => (
              <Flex pl="45px">
                <Checkbox
                  checked={!!field.value}
                  onChange={() => field.onChange(!field.value)}
                >
                  <Text fontSize="12px">Enviar cópia por email</Text>
                </Checkbox>
              </Flex>
            )}
          />

          <Field
            name="assuntoCustomizado"
            rules={{ required: true }}
            control={control}
            render={({ field, isInvalid }) => (
              <Flex alignItems="center">
                <Text fontSize={14} mr={4}>
                  Assunto:{" "}
                </Text>
                <Input
                  onChange={field.onChange}
                  value={field.value}
                  isInvalid={isInvalid}
                  bg={colors.white}
                  size={windowState === "maximized" ? "md" : "sm"}
                  rounded={6}
                  disabled={form.assuntoId !== AssuntoMensagem.Outros}
                  placeholder="Digite ou escolha o assunto"
                />
              </Flex>
            )}
          />

          <Field
            name="assuntoId"
            rules={{ required: true }}
            control={control}
            render={({ field, isInvalid }) => (
              <Flex alignItems="center">
                <SelectAssuntoMensagem
                  onChange={({ id, nome }) => {
                    field.onChange(id);
                    if (id !== AssuntoMensagem.Outros) {
                      setValue("assuntoCustomizado", nome);
                    }
                  }}
                  value={field.value}
                  isInvalid={isInvalid}
                />
              </Flex>
            )}
          />
        </>
      )}

      <Field
        name="conteudo"
        control={control}
        rules={{ required: true }}
        render={({ field, isInvalid }) => (
          // <Textarea
          //   isInvalid={isInvalid}
          //   style={{
          //     padding: 4,
          //     marginTop: 8,
          //   }}
          //   className="chakra-input"
          //   rows={9}
          //   minH="200px"
          //   resize="none"
          //   overflow="auto"
          //   placeholder="Digite sua mensagem..."
          //   {...field}
          // />

          <MessageEditor value={field.value} onChange={onChange} />
        )}
      />
    </>
  );
}

export default FormNovaMensagem;
